import { AxiosError, AxiosResponse, AxiosStatic } from 'axios';
import { toastr } from 'react-redux-toastr';

export function includeErrorInterceptor(axios: AxiosStatic) {
  axios.interceptors.response.use(
    (resp: AxiosResponse<any>) => resp,
    async (error: AxiosError) => {
      if (error.response && error.response.status !== 400) {
        toastr.error('Unexpected error', 'Error occurred, please try again later.');
      } else {
        return Promise.reject(error);
      }
    }
  );
}
